export const groupEngagementIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Group Summary Report is where you can see an overview of all student information. You can see student usage, progress, and engagement data.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade, class, or Extra Support setting.'
  },
  {
    element: '.district-report-header-group',
    intro: 'You are on the Engagement page of the Group Summary. The Engagement page includes points, team data, and level and task completion. Click on Usage and Progress to see student usage and progress data. The Usage and Progress page includes the current placement, level, zone, and weekly minutes.'
  },
  {
    element: '#show-teacher-column',
    intro: 'Select this checkbox to show the teacher column in this report.'
  },
  {
    element: '#hide-shared-students',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the student list below will only display those you are directly assigned to — excluding any students you\'re listed as a co-teacher for.'
  },
  {
    element: 'refresh-button',
    intro: 'Click here to refresh the Group Summary data.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the report data to Excel for analysis and sharing.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Group Summary report.'
  },
  {
    element: 'table.report-table',
    intro: 'Click on any column header to sort the column.'
  },
  {
    element: 'table.report-table th:nth-child(1)',
    intro: 'See each student’s name. Click on the column header to sort the students alphabetically by last name.'
  },
  {
    element: 'table.report-table th:nth-child(2)',
    intro: 'See each student’s grade. Click on the column header to sort by grade.'
  },
  {
    element: 'table.report-table th:nth-child(3)',
    intro: 'See each student’s current team for the week.'
  },
  {
    element: 'table.report-table th:nth-child(4)',
    intro: 'See each student’s total points since starting WordFlight.'
  },
  {
    element: 'table.report-table th:nth-child(5)',
    intro: 'See each student’s total points for the previous week.'
  },
  {
    element: 'table.report-table th:nth-child(6)',
    intro: 'See each student’s number of levels they have completed during the current week. There are 5 levels within each unit.'
  },
  {
    element: 'table.report-table th:nth-child(7)',
    intro: 'See each student’s number of levels they completed during the previous week.'
  },
  {
    element: 'table.report-table th:nth-child(8)',
    intro: 'See each student’s number of tasks they have completed during the current week. There are 3-5 tasks within each level.'
  },
  {
    element: 'table.report-table th:nth-child(9)',
    intro: 'See each student’s number of tasks they completed during the previous week.'
  }
];